import Summary from "./bodyComponent/Summary";
import {useVersionContext} from "./context/GlobalContext";
import Summary2 from "./bodyComponent/Summary2";

function App() {
    const {getVersion} = useVersionContext();

    return (
        <>
            {getVersion() === 1 && (
                <Summary/>
            )}
            {/* version 2 */}
            {getVersion() === 2 && (
                <Summary2/>
            )}
        </>
    );
}

export default App;
